// extracted by mini-css-extract-plugin
export var button = "_bh-7";
export var buttonRow = "_bh-6";
export var fadeIn = "_bh-1";
export var gradient = "_bh-0";
export var panel = "_bh-2";
export var panelIn = "_bh-3";
export var subtitle = "_bh-5";
export var title = "_bh-4";